import { ERROR_KEYS as AUTH_SESSION_ERROR_KEYS } from '../requestAuthSessionParams'
import { ERROR_KEYS as AUTH_TOKEN_ERROR_KEYS } from '../requestAuthToken'
import { ERROR_KEYS as CAPTCHA_PASSWORD_RESET_ERROR_KEYS } from '../requestCaptchaPasswordReset'
import { ERROR_KEYS as MAGIC_LINK_ERROR_KEYS } from '../requestMagicLink'
import { ERROR_KEYS as PASSWORD_RESET_ERROR_KEYS } from '../requestPasswordReset'
import { ERROR_KEYS as SUBMIT_PASSWORD_RESET_ERROR_KEYS } from '../submitPasswordReset'
import { ERROR_KEYS as SSO_SESSION_ERROR_KEYS } from '../validateIdentityProviderAndRedirect'

// ERROR_KEYS entries are either { key } or { someErrorCode: { key } }
const collectKeys = (errorKeys) =>
  Object.values(errorKeys).flatMap((value) => {
    if (typeof value === 'string') {
      return [value]
    }
    return value.key ? [value.key] : collectKeys(value)
  })

const HANDLED_ERROR_KEYS = new Set(
  [
    AUTH_SESSION_ERROR_KEYS,
    AUTH_TOKEN_ERROR_KEYS,
    CAPTCHA_PASSWORD_RESET_ERROR_KEYS,
    MAGIC_LINK_ERROR_KEYS,
    PASSWORD_RESET_ERROR_KEYS,
    SSO_SESSION_ERROR_KEYS,
    SUBMIT_PASSWORD_RESET_ERROR_KEYS,
  ].flatMap((errorKeys) => collectKeys(errorKeys)),
).add('')

const isHandledErrorKey = (reason) => typeof reason === 'string' && HANDLED_ERROR_KEYS.has(reason)

export { HANDLED_ERROR_KEYS, isHandledErrorKey }
